import {ApolloLink, Observable} from "@apollo/client";


/**
 * Приводит логические ошибки к единому формату
 * graphQLErrors: [
 *    ...
 *    {
 *        ...,
 *        message: техническое описание ошибки,
 *        extensions: {
 *            code: числовой код ошибки
 *            message: текст для пользователя
 *        }
 *    }
 * ]
 */
export function modifyResult(result) {
    /*
        Логическая ошибка 1С в старом формате:
        {
            ...
            ErrorInfo: {
                ID: int (код ошибки)
                Discription: string (описание ошибки)
            }
        }
     */
    if (result?.ErrorInfo) {
        return {
            ...result,
            errors: [...(result.errors || []), {
                message: result.ErrorInfo.Discription,
                extensions: {
                    code: result?.ErrorInfo.ID,
                    message: result.ErrorInfo.Discription,
                }
            }]
        }
    }

    /*
        Логическая ошибка 1С сервера в новом формате:
        {
            ...
            code: int (код ошибки)
            description: string ()
            message: string (текст сообщения для пользователя)
        }
     */
    if (result?.code > 0) {
        return {
            ...result,
            errors: [...(result.errors || []), {
                message: result.description,
                extensions: {
                    code: result.code,
                    message: result.message
                }
            }]
        }
    }

    /*
        Логическая ошибка сервера rest_framework:
        {
            ...
            code: string (код ошибки)
            description: string ()
            message: string (текст сообщения для пользователя)
        }
     */
    if (result?.code) {
        return {
            ...result,
            errors: [...(result.errors || []), {
                message: result.description,
                extensions: {
                    code: result.code,
                    message: result.message
                }
            }]
        }
    }
    return result;
}


export function createErrorLink() {
    return new ApolloLink((operation, forward) => {
        return new Observable(observer => {
            let sub;
            try {
                sub = forward(operation).subscribe({
                    next: result => {
                        observer.next(modifyResult(result));
                    },
                    error: networkError => {
                        const result = modifyResult(networkError.result);

                        if (result?.errors?.length > 0) {
                            observer.next(result);
                        } else {
                            observer.error(networkError);
                        }
                    },
                    complete: observer.complete.bind(observer)
                });
            } catch (e) {
                observer.error(e);
            }

            return () => {
                sub && sub.unsubscribe();
            };
        })
    });
}